<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent-head"><a id="page_ii"></a><span class="bold">The Emerging Civil War Series</span></p>
<p class="noindent-head1"><span class="bold">offers compelling, easy-to-read overviews of some of the Civil War’s most important battles and stories.</span></p>
<p class="noindent-fm"><em class="italic">Recipient of the Army Historical Foundation’s Lieutenant General Richard G. Trefry Award for contributions to the literature on the history of the U.S. Army</em></p>
<div class="image_container">
<img alt="images" src="images/f00ii-01.jpg"/>
<p class="captionC"><span class="bold">For a complete list of titles in the Emerging Civil War Series,<br/> visit <a href="http://www.emergingcivilwar.com" target="_blank">www.emergingcivilwar.com</a>.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Fm01.vue?264707b0